<ng-template #template>
  <ng-container *ngIf="isDisplayed">
    <div class="l-mybooking__option-item">
      <asw-next-action-item
        (clickNextAction)="onClick()"
        [canBeClicked]="canBeClicked"
        [title]="'label.juniorPilotHeadline' | staticMsg"
        [titleAria]="'reader.juniorPilotService' | staticMsg"
        [textContent]="'label.juniorPilotText' | staticMsg"
        itemId="junior-pilot"
      >
      </asw-next-action-item>
    </div>
  </ng-container>
</ng-template>
